"use strict";

// Shim for next/amp, which was removed in Next.js 15. The vendored
// react-storefront components only call useAmp() to branch on AMP rendering;
// this app never serves AMP, so useAmp() always returns false.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAmp = function useAmp() {
  return false;
};
